import { render, staticRenderFns } from "./UserDeleteModal.vue?vue&type=template&id=f945869a&scoped=true&"
import script from "./UserDeleteModal.vue?vue&type=script&lang=js&"
export * from "./UserDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f945869a",
  null
  
)

export default component.exports